import React, { useEffect, useState } from 'react';

const times = Array.from({ length: 48 }, (_, index) => {
  const hours = Math.floor(index / 2);
  const minutes = index % 2 ? '30' : '00';
  return {
    value: `${String(hours).padStart(2, '0')}:${minutes}`,
    label: `${hours % 12 || 12}:${minutes} ${hours < 12 ? 'AM' : 'PM'}`
  };
});

const ScheduleTimeField = ({ value, onValueChange, label, dated = false, style }) => {
  const [date, setDate] = useState(dated ? value.split('T')[0] : '');
  useEffect(() => { setDate(dated ? value.split('T')[0] : ''); }, [value, dated]);
  const time = dated ? (value.split('T')[1] || '').slice(0, 5) : value;
  const select = (
    <select aria-label={label} value={time} disabled={dated && !date} onChange={event => onValueChange(dated ? (event.target.value ? `${date}T${event.target.value}` : '') : event.target.value)} style={style}>
      <option value="">Select time</option>
      {time && !times.some(option => option.value === time) && <option value={time} disabled>{time} (existing)</option>}
      {times.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
    </select>
  );
  return dated ? (
    <div className="schedule-date-time-field">
      <input aria-label={`${label} date`} type="date" value={date} onChange={event => {
        setDate(event.target.value);
        if (time || !event.target.value) onValueChange(event.target.value ? `${event.target.value}T${time}` : '');
      }} style={style} />
      {select}
    </div>
  ) : select;
};

export default ScheduleTimeField;
